// extracted by mini-css-extract-plugin
export default {"header":"desktop_header__DH2G5","navigation":"desktop_navigation__VI503"};